import { muiIcons } from './mui.icons';
import { customIcons } from './custom.icons';

export const icons: Record<string, any> = {
  ...muiIcons,
  ...customIcons,
};
